/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAuthenticationConstraint } from './UserAuthenticationConstraint';
import {
    UserAuthenticationConstraintFromJSON,
    UserAuthenticationConstraintFromJSONTyped,
    UserAuthenticationConstraintToJSON,
    UserAuthenticationConstraintToJSONTyped,
} from './UserAuthenticationConstraint';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';
import type { AccessRequestApprovalType } from './AccessRequestApprovalType';
import {
    AccessRequestApprovalTypeFromJSON,
    AccessRequestApprovalTypeFromJSONTyped,
    AccessRequestApprovalTypeToJSON,
    AccessRequestApprovalTypeToJSONTyped,
} from './AccessRequestApprovalType';

/**
 * 
 * @export
 * @interface PermissionUpdateRequest
 */
export interface PermissionUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionUpdateRequest
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionUpdateRequest
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionUpdateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionUpdateRequest
     */
    applicationId?: string | null;
    /**
     * 
     * @type {any}
     * @memberof PermissionUpdateRequest
     */
    organizationGroupId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionUpdateRequest
     */
    tags?: string | null;
    /**
     * 
     * @type {UserType}
     * @memberof PermissionUpdateRequest
     */
    userType?: UserType;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionUpdateRequest
     */
    canBeRequestedByUsers?: boolean;
    /**
     * 
     * @type {UserAuthenticationConstraint}
     * @memberof PermissionUpdateRequest
     */
    userAuthenticationConstraint?: UserAuthenticationConstraint;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionUpdateRequest
     */
    requireUserOrganizationInMinSide?: boolean | null;
    /**
     * 
     * @type {AccessRequestApprovalType}
     * @memberof PermissionUpdateRequest
     */
    accessRequestApprovalType?: AccessRequestApprovalType;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionUpdateRequest
     */
    requiresMfa?: boolean;
    /**
     * 
     * @type {any}
     * @memberof PermissionUpdateRequest
     */
    accessExpirationId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionUpdateRequest
     */
    requiresReasonForAsking?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PermissionUpdateRequest
     */
    helpTextReasonField?: string | null;
}



/**
 * Check if a given object implements the PermissionUpdateRequest interface.
 */
export function instanceOfPermissionUpdateRequest(value: object): value is PermissionUpdateRequest {
    return true;
}

export function PermissionUpdateRequestFromJSON(json: any): PermissionUpdateRequest {
    return PermissionUpdateRequestFromJSONTyped(json, false);
}

export function PermissionUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'organizationGroupId': json['organizationGroupId'] === undefined ? undefined : json['organizationGroupId'] === null ? null : json['organizationGroupId'],
        'tags': json['tags'] === undefined ? undefined : json['tags'] === null ? null : json['tags'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'canBeRequestedByUsers': json['canBeRequestedByUsers'] == null ? undefined : json['canBeRequestedByUsers'],
        'userAuthenticationConstraint': json['userAuthenticationConstraint'] == null ? undefined : UserAuthenticationConstraintFromJSON(json['userAuthenticationConstraint']),
        'requireUserOrganizationInMinSide': json['requireUserOrganizationInMinSide'] === undefined ? undefined : json['requireUserOrganizationInMinSide'] === null ? null : json['requireUserOrganizationInMinSide'],
        'accessRequestApprovalType': json['accessRequestApprovalType'] == null ? undefined : AccessRequestApprovalTypeFromJSON(json['accessRequestApprovalType']),
        'requiresMfa': json['requiresMfa'] == null ? undefined : json['requiresMfa'],
        'accessExpirationId': json['accessExpirationId'] === undefined ? undefined : json['accessExpirationId'] === null ? null : json['accessExpirationId'],
        'requiresReasonForAsking': json['requiresReasonForAsking'] == null ? undefined : json['requiresReasonForAsking'],
        'helpTextReasonField': json['helpTextReasonField'] === undefined ? undefined : json['helpTextReasonField'] === null ? null : json['helpTextReasonField'],
    };
}

export function PermissionUpdateRequestToJSON(json: any): PermissionUpdateRequest {
    return PermissionUpdateRequestToJSONTyped(json, false);
}

export function PermissionUpdateRequestToJSONTyped(value?: PermissionUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'shortName': value['shortName'],
        'description': value['description'],
        'applicationId': value['applicationId'],
        'organizationGroupId': value['organizationGroupId'],
        'tags': value['tags'],
        'userType': UserTypeToJSON(value['userType']),
        'canBeRequestedByUsers': value['canBeRequestedByUsers'],
        'userAuthenticationConstraint': UserAuthenticationConstraintToJSON(value['userAuthenticationConstraint']),
        'requireUserOrganizationInMinSide': value['requireUserOrganizationInMinSide'],
        'accessRequestApprovalType': AccessRequestApprovalTypeToJSON(value['accessRequestApprovalType']),
        'requiresMfa': value['requiresMfa'],
        'accessExpirationId': value['accessExpirationId'],
        'requiresReasonForAsking': value['requiresReasonForAsking'],
        'helpTextReasonField': value['helpTextReasonField'],
    };
}

